import { FC, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import ls from '@livesession/sdk';

import routes from '@constants/routes';
import useStore from '@hooks/useStore';
import Checkout from '@containers/checkout';
import CheckoutV2 from '@containers/checkout/v2';
import Deleted from '@containers/Deleted';
import NotFound from '@containers/NotFound';
import AccountsPayable from '@containers/AccountsPayable';
import { sendPageView } from '@utils/ga';
import { oytserLanding } from '@configs/variables';
import Loader from '@components/common/Loader';
import Processing from '@containers/Processing';
import Sura, { routesSura } from '@containers/Sura';

interface AppProps {}

const App: FC<AppProps> = () => {
  const history = useHistory();
  const location = useLocation();
  const { ui, sura, links } = useStore();

  useEffect(() => {
    sendPageView(location.pathname);
  }, [location]);

  useEffect(() => {
    ui.detectDeviceType();
    const handleResize = () => {
      ui.updateField('width', window.innerWidth);
      ui.updateField('height', window.innerHeight);
      if (sura.isSura) {
        if (window.innerWidth <= 999 && !ui.isMobileScreen) {
          ui.updateField('isMobileScreen', true);
        } else if (window.innerWidth > 999 && ui.isMobileScreen) {
          ui.updateField('isMobileScreen', false);
        }
      } else {
        if (window.innerWidth <= 600 && !ui.isMobileScreen) {
          ui.updateField('isMobileScreen', true);
        } else if (window.innerWidth > 600 && ui.isMobileScreen) {
          ui.updateField('isMobileScreen', false);
        }
      }
      if (window.innerHeight <= 500) {
        ui.setIsKeyboardPopped(true);
      } else {
        ui.setIsKeyboardPopped(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* useEffect(() => {
    if (links.paymentLink.businessId !== '') {
      try {
        console.log(
          'Inicializando LiveSession para paymentLinkId:',
          links.paymentLink.paymentLinkId,
        );

        ls.init(
          process.env.REACT_APP_LIVE_SESSION_ID || '',
          {
            debug: true,
            trackInputs: true,
            respectDoNotTrack: false,
            maskEmails: true,
            maskNumbers: true,
            keysTrokes: false,
          },
          {
            devMode: false,
            scriptURL: 'https://cdn.livesession.io/track.js',
          },
        );

        ls.identify({
          name: links.accountInfo.businessName,
          params: {
            businessId: links.paymentLink.businessId,
            userId: links.paymentLink.userId,
          },
        });

        ls.newPageView({
          title: links.paymentLink.paymentLinkId,
        });

        console.log('LiveSession initialized with user info');
      } catch (error) {
        console.error('Error al inicializar LiveSession:', error);
      }
    }
  }, [links.paymentLink.businessId, links.paymentLink.paymentLinkId]); */

  const redirectHandler: FC = () => {
    window.location.replace(oytserLanding);
    return <Loader />;
  };

  return (
    <>
      <Switch>
        <Route exact path={routes.HOME} component={redirectHandler} />
        <Route exact path={routes.CHECKOUT} component={Checkout} />
        <Route exact path={routes.CHECKOUT_V2} component={CheckoutV2} />
        <Route exact path={routes.DELETED} component={Deleted} />
        <Route exact path={routes.NOT_FOUND} component={NotFound} />
        <Route exact path={routes.PROCESSING} component={Processing} />
        <Route exact path={routes.ACCOUNT_PAYABLES} component={AccountsPayable} />
        <Route exact path={routesSura} component={Sura} />
        <Redirect from="*" to={{ ...history.location, pathname: routes.HOME }} />
      </Switch>
    </>
  );
};

export default observer(App);
